var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatformIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23156_15771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5835 11.9315C27.3805 12.089 23.7965 14.1085 23.7965 18.599C23.7965 23.793 28.357 25.6305 28.4935 25.676C28.4725 25.788 27.769 28.1925 26.089 30.6425C24.591 32.7985 23.0265 34.951 20.6465 34.951C18.2665 34.951 17.654 33.5685 14.9065 33.5685C12.229 33.5685 11.277 34.9965 9.1 34.9965C6.923 34.9965 5.404 33.0015 3.6575 30.5515C1.6345 27.6745 0 23.205 0 18.963C0 12.159 4.424 8.5505 8.778 8.5505C11.0915 8.5505 13.02 10.0695 14.4725 10.0695C15.855 10.0695 18.011 8.4595 20.643 8.4595C21.6405 8.4595 25.2245 8.5505 27.5835 11.9315ZM19.3935 5.579C20.482 4.2875 21.252 2.4955 21.252 0.7035C21.252 0.455 21.231 0.203 21.1855 0C19.4145 0.0665 17.3075 1.1795 16.037 2.653C15.0395 3.787 14.1085 5.579 14.1085 7.3955C14.1085 7.6685 14.154 7.9415 14.175 8.029C14.287 8.05 14.469 8.0745 14.651 8.0745C16.24 8.0745 18.2385 7.0105 19.3935 5.579Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23156_15771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.49,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformIos);
export default __webpack_public_path__ + "static/media/platform_ios.531379edcd2ea2ffc1b6bc0beab56ced.svg";
export { ForwardRef as ReactComponent };